var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInitiativeRoi(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 12,
    viewBox: "0 0 9 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.78145 2.77968C9.07441 2.48671 9.07441 2.01093 8.78145 1.71796C8.48848 1.42499 8.0127 1.42499 7.71973 1.71796L0.219727 9.21796C-0.0732422 9.51093 -0.0732422 9.98671 0.219727 10.2797C0.512695 10.5726 0.988477 10.5726 1.28145 10.2797L8.78145 2.77968V2.77968M3.00176 2.99999C3.00176 2.17212 2.32963 1.49999 1.50176 1.49999C0.673885 1.49999 0.00175781 2.17212 0.00175781 2.99999C0.00175781 3.82786 0.673885 4.49999 1.50176 4.49999C2.32963 4.49999 3.00176 3.82786 3.00176 2.99999V2.99999M9.00176 8.99999C9.00176 8.17212 8.32963 7.49999 7.50176 7.49999C6.67389 7.49999 6.00176 8.17212 6.00176 8.99999C6.00176 9.82786 6.67389 10.5 7.50176 10.5C8.32963 10.5 9.00176 9.82786 9.00176 8.99999V8.99999",
    fill: "#1A4252"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInitiativeRoi);
export default __webpack_public_path__ + "static/media/initiative-roi.b72ee384c3c620e18683523165a5dad8.svg";
export { ForwardRef as ReactComponent };